module.exports = __webpack_public_path__ + "img/Attendance.dc6d4be7.svg";